import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const DOCUMENT = {
  GET_LIST: createActionTypes("GET_LISTA_DOCUMENT"),
  GET_DOCUMENT: createActionTypes("GET_DOCUMENT"),
  SAVE_DOCUMENT: createActionTypes("SAVE_DOCUMENT"),
  DUPLICATE_DOCUMENT: createActionTypes("DUPLICATE_DOCUMENT"),

  GET_DOCUMENT_HISTORY: createActionTypes("GET_DOCUMENT_HISTORY"),
  GET_DOCUMENT_HISTORY_LIST: createActionTypes("GET_DOCUMENT_HISTORY_LIST"),
  GET_DOCUMENT_ALL: createActionTypes("GET_DOCUMENT_ALL"),
  GET_DOCUMENT_PRODUCTS: createActionTypes("GET_DOCUMENT_PRODUCTS"),
  GET_DOCUMENT_SNIPPETS: createActionTypes("GET_DOCUMENT_SNIPPETS"),
  GET_DOCUMENT_SECTIONS: createActionTypes("GET_DOCUMENT_SECTIONS"),

  GET_DOCUMENT_PREVIEW: createActionTypes("GET_DOCUMENT_PREVIEW"),

  GET_DOWNLOAD_DOCUMENT: createActionTypes("GET_DOWNLOAD_DOCUMENT"),

  POST_DOCUMENT_DOWNLOAD_LIST: createActionTypes("POST_DOCUMENT_DOWNLOAD_LIST"),

  GET_DOCUMENT_DOWNLOAD_HISTORY: createActionTypes("GET_DOCUMENT_DOWNLOAD_HISTORY"),

  PUT_DOCUMENT_BULK_STATUS_UPDATE: createActionTypes("PUT_DOCUMENT_BULK_STATUS_UPDATE"),

  LOAD_EMPTY: "LOAD_EMPTY_DOCUMENT",
  CLEAN_MESSAGE: "CLEAN_MESSAGE_DOCUMENT",
  DISABLE_LOADING_DOCUMENT: "DISABLE_LOADING_DOCUMENT",
  CLEAN_ID_DOCUMENT_DUPLICATE: "CLEAN_ID_DOCUMENT_DUPLICATE",
  CHANGE_PAGE_SIZE_DOCUMENT: "CHANGE_PAGE_SIZE_DOCUMENT",
};
